import React, { useEffect, useState } from "react";
import { fetchAdjuntoBlob } from "../lib/portafolio";

/**
 * Muestra una imagen protegida detrás de auth. Descarga como blob y usa un
 * ObjectURL local. Ideal para portadas / thumbnails / previews del portafolio.
 */
export default function AuthedImage({ url, alt = "", className = "", fallback = null, testid }) {
  const [src, setSrc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!url) return;
    let objectUrl = null;
    let cancelled = false;
    setError(false);
    setSrc(null);
    fetchAdjuntoBlob(url)
      .then((u) => {
        if (cancelled) return URL.revokeObjectURL(u);
        objectUrl = u;
        setSrc(u);
      })
      .catch(() => !cancelled && setError(true));
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  if (!url || error) return fallback;
  if (!src) {
    return (
      <div
        className={`bg-slate-100 animate-pulse ${className}`}
        data-testid={testid ? `${testid}-loading` : undefined}
      />
    );
  }
  return <img src={src} alt={alt} className={className} data-testid={testid} />;
}
